import { useQuery } from '@tanstack/react-query'
import { queryKeys } from 'commons/hooks/services/queryKeys'
import { successLydiaPageService } from 'commons/services/successService'

const useSuccessLydiaPageInfo = ({ identifier }: { identifier: string }) => {
	return useQuery({
		queryKey: queryKeys.successLydiaPageInfo.getSuccessLydiaPageInfo(identifier),
		queryFn: () => successLydiaPageService.getSuccessLydiaPageInfo(identifier)
	})
}

export default useSuccessLydiaPageInfo
